(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lumiaura-header"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    const link = event.target.closest('.la-header a');
    if (link) link.closest('.la-header').querySelectorAll('details[open]').forEach(function(menu) { menu.open = false; });
    document.querySelectorAll('.la-header details[open]').forEach(function(menu) {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') document.querySelectorAll('.la-header details[open]').forEach(function(menu) { menu.open = false; menu.querySelector('summary').focus(); });
  });

  } catch(e) { console.error(e); }
})();
})();
